export interface GeolocationCoordinates {
  latitude: number;
  longitude: number;
}

export interface GeolocationAddress {
  locationName?: string;
  address: string;
  city?: string;
  state?: string;
  country?: string;
  zipCode?: string;
}

export type GeolocationInput =
  | GeolocationCoordinates
  | GeolocationAddress
  | string;

export abstract class MapProvider {
  name: string;
  abstract generateUrl(destination: GeolocationInput): string;
  protected isCoordinates(location: any): location is GeolocationCoordinates {
    return 'latitude' in location && 'longitude' in location;
  }
}
